import { requiredRoles, themeObject } from 'lib';
import { Dashboard as DashboardIcon } from '@mui/icons-material';
import {
    LifgraphNavIcon,
    ContractsNavIcon,
    HelpNavIcon,
    JobManagerNavIcon,
    ConfigurationIcon,
    SystemAlertsIcon,
} from 'assets/images';
import { WALLETS_AND_GROUPS_PATHS } from 'constants/wallets-and-groups-paths';
import { CONSENT_CONTRACT_PATHS } from 'constants/consent-contracts-paths';
import { SMART_CONTRACT_PATHS } from 'constants/smart-contracts-paths';
import { DICTIONARY_PATHS } from '../../../../constants/dictionary-paths';
import { EDGE_DEFINITION_PATHS } from '../../../../constants/edge-definition-paths';
import { JOB_MANAGER_PATHS } from '../../../../constants/job-manager-paths';
import { PIPELINES_AND_STEPS_PATHS } from '../../../../constants/pipelines-and-steps-paths';
import { SINGLE_NAVIGATION_PATHS } from '../../../../constants/single-navigation-paths';
import { GLOSSARY_METADATA_PATHS } from 'constants/glossary-metadata-paths';

export const styles = {
    sideNavStyles: {
        zIndex: 999,
        '& .MuiPaper-root': {
            '& .drawer-content': {
                '& .navigation-container': {
                    '& .navigation-icon-container.group': {
                        '&:hover': {
                            '& .navigation-inner-icon-container.group-expanded':
                                {
                                    backgroundColor: `${themeObject.palette.background.paper} !important`,
                                },
                        },
                        '& .navigation-inner-icon-container.group-expanded': {
                            backgroundColor: `${themeObject.palette.background.paper} !important`,
                        },
                        '& .navigation-group-inner-icon-container': {
                            '& .navigation-icon-group.with-icon': {
                                justifyContent: 'space-between',
                            },
                        },
                    },
                },
            },
        },
    },
    glossaryMetadataIcon: {
        height: '18px',
        width: '18px',
    },
    downloadSwaggerJSONIcon: {
        height: '22px',
        width: '22px',
    },
};

export const sideNavItems = [
    {
        icon: <DashboardIcon />,
        isActive: true,
        title: 'Dashboard',
        path: SINGLE_NAVIGATION_PATHS.DASHBOARD,
        showDivider: true,
    },
    {
        groupIcon: <img src={LifgraphNavIcon} alt='lifegraph-icon' />,
        groupName: 'LifeGraph',
        tabItems: [
            {
                isActive: false,
                title: 'Explorer',
                path: SINGLE_NAVIGATION_PATHS.LIFEGRAPH,
                requiredRoles: requiredRoles.lifegraph,
            },
            {
                isActive: false,
                title: 'TQL Editor',
                path: SINGLE_NAVIGATION_PATHS.TQL_EDITOR,
                requiredRoles: requiredRoles.tqlEditor,
            },
        ],
    },
    {
        groupIcon: <img src={ContractsNavIcon} alt='contracts-icon' />,
        groupName: 'Contracts',
        tabItems: [
            {
                isActive: false,
                title: 'Consent Contracts',
                path: CONSENT_CONTRACT_PATHS.LANDING_PAGE,
                requiredRoles: requiredRoles.consentContract,
            },
            {
                isActive: false,
                title: 'Smart Contracts',
                path: SMART_CONTRACT_PATHS.LANDING_PAGE,
                requiredRoles: requiredRoles.smartContract,
            },
        ],
    },
    {
        icon: <img src={JobManagerNavIcon} alt='job-manager-icon' />,
        isActive: false,
        title: 'Job Manager',
        path: JOB_MANAGER_PATHS.LANDING_PAGE,
        requiredRoles: requiredRoles.jobManager,
        showDivider: true,
    },
    {
        groupIcon: <img src={ConfigurationIcon} alt='configuration-icon' />,
        groupName: 'Configuration',
        tabItems: [
            {
                isActive: false,
                title: 'Dictionaries',
                path: DICTIONARY_PATHS.LANDING_PAGE,
                requiredRoles: requiredRoles.dictionary,
            },
            {
                isActive: false,
                title: 'Edge Definitions',
                path: EDGE_DEFINITION_PATHS.LANDING_PAGE,
                requiredRoles: requiredRoles.dictionary,
            },
            {
                isActive: false,
                title: 'Wallets & Groups',
                path: WALLETS_AND_GROUPS_PATHS.WALLETS_AND_GROUPS_PATH,
                requiredRoles: requiredRoles.walletsAndGroups,
            },
            {
                isActive: false,
                title: 'Pipelines',
                path: PIPELINES_AND_STEPS_PATHS.LANDING_PAGE,
                requiredRoles: requiredRoles.pipelines,
            },
            {
                isActive: false,
                title: 'Glossary',
                path: GLOSSARY_METADATA_PATHS.LANDING_PAGE,
                requiredRoles: requiredRoles.glossaryMetadata,
            },
            {
                isActive: false,
                title: 'Global Search',
                path: SINGLE_NAVIGATION_PATHS.METADATA_SEARCH,
            },
            {
                isActive: false,
                title: 'Export',
                path: SINGLE_NAVIGATION_PATHS.EXPORT,
            },
        ],
    },
];

export const pinnedSideNavItems = (): any[] => {
    const results = [
        {
            icon: <img src={SystemAlertsIcon} alt='system-alerts-icon' />,
            isActive: false,
            title: 'System Alerts',
            path: SINGLE_NAVIGATION_PATHS.SYSTEM_MESSAGES,
        },
        {
            groupIcon: <img src={HelpNavIcon} alt='help-icon' />,
            groupName: 'Help',
            tabItems: [
                {
                    isActive: false,
                    title: 'Documentation',
                    path: process.env.REACT_APP_DEV_DOCS_URL,
                    openLinkInNewTab: true,
                },
                {
                    isActive: false,
                    title: 'Ask Blast',
                    path: SINGLE_NAVIGATION_PATHS.ASK_BLAST,
                },
                {
                    isActive: false,
                    title: 'Help Desk',
                    path: SINGLE_NAVIGATION_PATHS.HELP_DESK,
                    displayNewTabIcon: true,
                    requiredRoles: requiredRoles.helpDesk,
                },
                {
                    isActive: false,
                    title: 'About',
                    path: SINGLE_NAVIGATION_PATHS.ABOUT_APP_VERSION,
                },
            ],
        },
    ];

    return results;
};
